import { ConfigProvider, Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { createContext, useContext, useEffect, useState } from 'react';
import Route from 'AppRoute';
import Header from 'components/layout/Header';
import './App.css';
import './AppDesk.css';
import './AppMobile.css';
import { useAuth } from 'AuthContext';
import Footer from 'components/layout/Footer';
import viVN from 'antd/locale/vi_VN';
import FullMask from 'components/layout/FullMask';
import 'katex/dist/katex.min.css';

const MaskContext = createContext();

export default function App() {
    const [header, setHeader] = useState(false);
    const [fullMask, setFullMask] = useState(false);
    const { getUserInfo } = useAuth();
    useEffect(()=>{
        getUserInfo();
    },[getUserInfo])
    return (
        <ConfigProvider locale={viVN} theme={{ token: { colorPrimary: '#018F41' }, cssVar: true }}>
            <MaskContext.Provider value={{ setFullMask }}>
                <Layout className="layout" style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
                    {header && <Header />}
                    <Content >
                        <div className="main-div site-layout-content container p-3 mt-3 mb-3">
                            <Route setHeader={setHeader}/>
                        </div>
                    </Content>
                    {header && <Footer/>}
                </Layout>
            </MaskContext.Provider>
            {fullMask && <FullMask />}
        </ConfigProvider>
    );
}

const useMask = () => useContext(MaskContext);

export { useMask }